import { render, staticRenderFns } from "./SuggestionBlock.vue?vue&type=template&id=0a5f8440&lang=pug&"
import script from "./SuggestionBlock.vue?vue&type=script&lang=js&"
export * from "./SuggestionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports